import { useEffect, useState } from "react";
import { getLiveStatus } from "./redesignApi";

/*
 * Live status from the Castr webhook via GET /livestream/status, polled so
 * the (Live now)/(Offline) indicators flip without a reload. Shared by the
 * homepage strip and the /live page.
 * @returns {{state:'live'|'soon'|'offair', label?: string}|null} null until first response
 */
export default function useLiveStatus(intervalMs = 60000) {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const refresh = () => getLiveStatus().then((s) => !cancelled && setStatus(s));
    refresh();
    const id = setInterval(refresh, intervalMs);
    const onVisible = () => document.visibilityState === "visible" && refresh();
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      cancelled = true;
      clearInterval(id);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [intervalMs]);

  return status;
}
